import React from "react";
import classNames from "classnames";
import FsLightbox from 'fslightbox-react';

const PreviewProducts = (props) => {
  
  const renderPreviewButton = () => {
    const {
      previewActive,
      previewKey,
      previewPhotoSources,
      activatePreview,
      hidePreview
    } = props;

    return (
      <div className="preview-products__wrapper">
        <button
          className="btn btn-primary preview-products__button"
          onClick={ e => {
            e.preventDefault();
            activatePreview();
          }}
        >
          <i className="fa fa-eye"></i>
          Preview
        </button>
        <FsLightbox
          toggler={previewActive}
          sources={previewPhotoSources}
          type={"image"}
          onClose={hidePreview}
          key={previewKey}
        />        
      </div>
    )
  }
  
  const { previewPhotoSources } = props;

  if (!previewPhotoSources.length) {
    return null;
  } else {
    return renderPreviewButton();
  }
}

export default PreviewProducts;